import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page403',
  templateUrl: './page403.component.html',
  styleUrls: ['./page403.component.css']
})
export class Page403Component implements OnInit {

  constructor(private router : Router) { }

  ngOnInit(): void {
  }

  loginAgain() {
    this.router.navigateByUrl("/login");
  }
}
